export const scrollToElement = (target: HTMLElement | null, offset = 0) => {
  if (!target) {
    return;
  }

  const top = window.scrollY + target.getBoundingClientRect().top - offset;

  window.scrollTo({
    top: Math.max(0, top),
    behavior: "smooth",
  });
};

export const scrollToElementById = (targetId: string, offset = 0) => {
  scrollToElement(document.getElementById(targetId), offset);
};

export const scrollToHash = (hash: string, offset = 0) => {
  if (!hash) {
    return;
  }

  const selector = hash.startsWith("#") ? hash : `#${hash}`;
  scrollToElement(document.querySelector<HTMLElement>(selector), offset);
};
